import { appTheme } from './theme'
import CSS from 'csstype'

export const flexItemLeft: CSS.Properties = {
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',
  boxShadow: 'none'
}
export const flexItemRight: CSS.Properties = {
  display: 'flex',
  justifyContent: 'right',
  alignItems: 'right',
  boxShadow: 'none'
}

export const flexItemCenter: CSS.Properties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: 'none'
}

export const flexItemSpaceAround: CSS.Properties = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  boxShadow: 'none'
}

export const flexItemSpaceBetween: CSS.Properties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: 'none'
}

export const flexcol: CSS.Properties = {
  display: 'flex',
  flexDirection: 'column'
}

export const flexrow: CSS.Properties = {
  display: 'flex',
  flexDirection: 'row'
}

export const inputBoxStyle: CSS.Properties = {
  width: '270px',
  margin: '10px  auto 0'
}

export const flexItemColumn: CSS.Properties = {
  flexDirection: 'column',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: 'none',
  width: '100%',
  height: 'auto',
  [appTheme.breakpoints.up('md')]: {
    height: '100vh'
  }
}

export const flexItemColumnLeft: CSS.Properties = {
  flexDirection: 'column',
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'flex-start',
  boxShadow: 'none',
  width: '100%',
  height: 'auto',
  [appTheme.breakpoints.up('md')]: {
    height: '100vh'
  }
}

export const loginSignupButton: CSS.Properties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '63px',
  width: '100%',
  padding: '10px 24px',
  fontWeight: 'bold',
  margin: '10px',
  boxShadow: 'none'
}

export const buttonStyle: CSS.Properties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '63px',
  width: 'auto',
  padding: '10px 24px',
  fontWeight: 'bold',
  margin: '10px',
  boxShadow: 'none',
  textTransform: 'capitalize'
}

export const inputFiledStyle: CSS.Properties = {
  width: '100%',
  margin: '15px 0',
  [appTheme.breakpoints.up('md')]: {
    margin: '15px 0'
  }
}

export const pseudos: {
  [inputFiledStyle in CSS.SimplePseudos]?: CSS.Properties
} = {
  ':hover': {
    width: '50%'
  }
}

export const loginSignupImageStyle: CSS.Properties = {
  width: '100%',
  maxWidth: '224px',
  margin: '0 auto'
}

export const container: CSS.Properties = {
  maxWidth: '1280px',
  margin: '0 auto'
}

export const closeIcon: CSS.Properties = {
  float: 'right',
  margin: '0.5rem',
  position: 'static',
  [appTheme.breakpoints.down('lg')]: {
    right: '0.5rem',
    margin: '0',
    position: 'absolute',
    top: '0.5rem'
  }
}

export const root: CSS.Properties = {
  width: 'flex',
  height: 'calc(100vh - 72px)',
  overflow: 'auto',
  [appTheme.breakpoints.down('xl')]: {
    margin: '0',
    padding: '0 32px 0 80px'
  }
  // [appTheme.breakpoints.up("sm")]: {
  //   margin: "0",
  //   padding: '0 19px'
  // },
}

export const verticalBorders: CSS.Properties = {
  borderRight: "1px solid #e0e0e0",
  borderLeft: "1px solid #e0e0e0"
}

export const gridColumn: CSS.Properties = {
  padding: '0 20px'
}

export const noSpacing: CSS.Properties = {
  padding: '0',
  margin: '0'
}

export const dialogButtons: CSS.Properties = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
  marginTop: '24px'
}

export const flexItemRightGap: CSS.Properties = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
}